import {
  SECTION_AUDIO,
  SECTION_IMAGE,
  SECTION_TEXT,
} from '../../common/CardEditorConstants';
import CardEditor from '../../common/card-editor/CardEditor';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';
import './PageInstructionEditor.scss';

const defaultProps = {
  isSelected: false,
  selectedSection: SECTION_TEXT,
  onSectionSelected: () => null,
  instructions: {},
};

export default function PageInstructionEditor(props) {
  const {
    selectedSection,
    onSectionSelected,
    instructions,
    isSelected,
  } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div className='page-instruction-editor'>
      <CardEditor
        config={{
          text: instructions.text,
          image: instructions.image,
          video: instructions.video,
          audio: instructions.audio,
        }}
        isSelected={isSelected}
        selectedSection={selectedSection}
        onImageSelected={() => {
          onSectionSelected(SECTION_IMAGE);
        }}
        onTextSelected={() => {
          onSectionSelected(SECTION_TEXT);
        }}
        onAudioSelected={() => {
          onSectionSelected(SECTION_AUDIO);
        }}
        isVideoIncluded={false}
      />
    </div>
  );
}
